const _export = {
    svg: '<svg style="width:1.00rem; height:1.00rem;" viewBox="0 0 16 16"><path d="M1.5 9.817V14.5h13V9.817H16V16H0V9.817zM8 0l5.434 5.423-1.01 1.119-3.662-3.67V12H7.25V2.873L3.587 6.542l-1.01-1.12z"/></svg>',
};

export { _export as default };
